var lib_core = require("lib-core");

var PropValueData = function (name, defaultValue, valueMin, valueMax) {
    this.makeObservableTreeNode();

    this.name = this.value("name", true);
   	this.defaultValue = this.value("defaultValue", true);

    // value constraints
    this.valueMin = this.value("valueMin", true);
    this.valueMax = this.value("valueMax", true);
    this.valueList = this.list("valueList", true);
    this.restrictiveValueList = this.value("restrictiveValueList", true);   // defines if value is restricted to values from the list

    if(name) this.name(name); else this.name("");
    if(defaultValue) this.defaultValue(defaultValue); else this.defaultValue("");
    if(valueMin != undefined) this.valueMin(valueMin);
    if(valueMax != undefined) this.valueMax(valueMax);
};
lib_core.mixin(PropValueData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PropValueData, "PropValueData");

module.exports = PropValueData;

PropValueData.prototype.hasValueList = function(){
    return (this.valueList.size() > 0);
};
